import { render, staticRenderFns } from "./TeamMember.vue?vue&type=template&id=9a600bca"
import script from "./TeamMember.vue?vue&type=script&lang=js"
export * from "./TeamMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CornerIcon: require('/vercel/path0/components/icons/CornerIcon.vue').default,PhoneIcon: require('/vercel/path0/components/icons/PhoneIcon.vue').default,MailIcon: require('/vercel/path0/components/icons/MailIcon.vue').default})
